<template>
  <div class="container p-0">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between" v-if="shipmentD">
          <div class="d-flex col-md-3">
            <!-- <i class="fas fa-arrow-left fs-1 me-10" style="cursor:pointer" @click="$router.push(backRoute)"></i> -->
            <i class="fas fa-arrow-left fs-1 me-10" style="cursor:pointer" @click="fromOverDue?$router.go(-1):$router.push({name: 'shipment2SList', params: {status:this.status}})"></i>
            <div class="d-flex">
              <h2>#{{ uoRefNo }} </h2>&nbsp;
              <span class="text-muted mt-1" >
                  [ {{ formatDateTimeFromISO(shipmentD.created_at) }}]    
              </span>
            </div>
          </div>          
          <div class="d-flex col-md-4 justify-content-center mt-2">
            <span class="text-muted">ใบส่งสินค้า</span> &nbsp;&nbsp;
            <span class="text-success">{{shipmentD.shipmentCode }}</span> &nbsp;&nbsp;
            <span class="text-muted">ใบกำกับ</span> &nbsp;&nbsp;
            <span  class="text-primary" >{{shipmentD.invoiceCode }} </span>  
          
          </div>
          <div class="d-flex col-md-5 justify-content-end mt-2">
            <span class="text-muted" v-if="shipmentD && shipmentD.delivery_method && shipmentD.delivery_method.trim() == 'pickup'" >รับเอง</span>
            <span  class="text-muted" v-else >จัดส่ง </span>  &nbsp;&nbsp;
            <span> {{ formatDateTimeFromISO(shipmentD.partnerDeliveryDate) }}</span>&nbsp;&nbsp;
            <span   v-if="shipmentD.pnTruckCode" > <span  class="text-muted">ทะเบียน</span> &nbsp;&nbsp; {{shipmentD.pnTruckCode }}   </span> 
            <span   v-if="shipmentD.cusTruckCode" > <span  class="text-muted">ทะเบียน</span> &nbsp;&nbsp; {{shipmentD.cusTruckCode }}   </span> 
             
            
          
          </div>
          <div class="d-flex col-md-4 justify-content-end" v-if="status !='success'">       
            <print-delivery-2-s-online
              class="btn btn-sm btn-primary"
              :disabled="shipmentD && (shipmentD.isComplete || (shipmentD.delivery_method && shipmentD.delivery_method.trim() != 'pickup' && !shipmentD.pnTruckCode) )"
              :uoRefNo="shipmentD && shipmentD.uoRefNo" :shipmentCode="shipmentD && shipmentD.shipmentCode"
              @update="getShipmentD">
            </print-delivery-2-s-online>
            &nbsp;&nbsp;
            <button class="btn btn-sm btn-dark-green" @click="ConfirmShipment" :disabled="shipmentD && (shipmentD.isComplete || (shipmentD.delivery_method && shipmentD.delivery_method.trim() != 'pickup' && (!shipmentD.pnTruckCode || !shipmentD.shipmentCode)) ) ">
              <i class="fas fa-check" style="color: #fff;"></i>
              <!-- ยืนยันส่งสินค้า -->
            </button>
            &nbsp;&nbsp;
            <button
              class="btn btn-sm btn-danger"
              @click="CancelShipmentData" :disabled="shipmentD && (shipmentD.isComplete || shipmentD.orderCancel || (shipmentD.delivery_method && shipmentD.delivery_method.trim() != 'pickup' && (!shipmentD.pnTruckCode || !shipmentD.shipmentCode)))"
            >
              <i class="fas fa-trash"></i>
              <!-- ยกเลิกส่งสินค้า  -->
            </button>
          </div>
        </div>
        
        <div class="card my-5 bg-light rounded fs-6" v-if="shipmentD">
          <div class="card-body text-gray-700">
            <div class="row">
              <div class="col-md-6">
                <div class="fs-4 fw-bolder mb-3 text-gray-500">
                  ลูกค้า
                </div>
                <div class="d-flex mb-2">
                  <div class="fw-bolder me-5 " style="width: 90px">ชื่อลูกค้า</div>
                  <div>{{ shipmentD.cusname }}</div>
                </div>
                <div class="d-flex mb-2">
                  <div class="fw-bolder me-5 "  style="width: 90px">เบอร์โทรศัพท์</div>
                  <div>{{ shipmentD.cusmobile }}</div>
                </div>
                <div class="d-flex flex-row mb-2">
                  <div class="fw-bolder me-5 "  style="width: 90px">ที่อยู่</div>
                  <div style="white-space: initial; word-wrap: break-word;">{{ shipmentD.delivery_address }}</div>
                </div>
              </div>
              <div  class="col-md-6">
                <div
                  class="
                    separator separator-dashed
                    border-gray-500
                    my-5
                    d-md-none
                  "
                ></div>
                <div class=" mb-3 d-flex align-items-center " v-if="shipmentD.checkedIS">
                  <el-checkbox 
                    v-model="shipmentD.checkedIS" 
                    :disabled="true"
                    class="invoice-check-box" >ต้องการใบกำกับภาษี 
                    
                  </el-checkbox>
                  <!-- <button
                   v-if="shipmentD.requestTaxInvoice && shipmentD.customerTaxName && !shipmentD.lastPrintTaxInvoiceDate && !shipmentD.isPosted"
                    @click="() => !order.lastPrintTaxInvoiceDate && $refs.customerAddressModal.show()"
                    class="btn btn-text-primary fs-6 py-0 pe-0 d-flex flex-row"
                    type="button"
                  >
                    <i class="bi bi-pencil-square mt-1"></i>
                      แก้ไข
                  </button> -->
                </div>
                <div v-if="shipmentD.checkedIS">
                 
                  <div >  <!-- v-if="shipmentD.customerTaxName" -->
                    <div class="d-flex mb-2">
                      <div class="w-100px fw-bolder me-5">ชื่อ</div>
                      <div>{{ shipmentD.billName }}</div>
                    </div>
                    <div class="d-flex mb-2">
                      <div class="w-100px fw-bolder me-5">ที่อยู่</div>
                      <div>{{ shipmentD.billAddress }}</div>
                    </div>
                   
                    <div class="d-flex mb-2"   >  <!-- v-if="(shipmentD.customerTaxID&&shipmentD.customerTaxID.trim() != '')" -->
                      <div class="w-160px fw-bolder me-5">
                        เลขประจำตัวผู้เสียภาษี
                      </div>
                      <div>
                        {{ shipmentD.billTaxID }} &nbsp; &nbsp;
                        {{ billTaxBranchDisplay }}
                      </div>
                    </div>
                  </div>
                  <!-- <div v-else>
                    <button class="btn btn-light" @click="$refs.customerAddressModal.show">
                      เลือกที่อยู่ออกบิล
                    </button>
                    
                  </div> -->
                  <search-customer-address-modal
                    ref="customerAddressModal"
                    @select="onSelectAddress"
                    :customerId="shipmentD.customerID"
                  ></search-customer-address-modal>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive " v-if="shipmentD">
          <!--begin::Table-->
          <table
            class="table g-5 gs-0 mb-0 fw-bolder text-gray-700"
            data-kt-element="items"
          >
            <!--begin::Table head-->
            <thead>
              <tr
                class="
                  border-bottom
                  fs-7
                  fw-bolder
                  text-gray-700 text-uppercase
                "
              >
                <th class="min-w-50px w-50px">#</th>
                <th class="min-w-300px w-475px">สินค้า</th>
                <th class="min-w-90px text-end w-90px">จำนวน</th>
                <!-- <th class="min-w-100px w-100px text-end">น้ำหนัก</th> -->
                <th class="min-w-150px w-100px text-end">ราคา</th>
                <th class="min-w-100px w-100px text-end">น้ำหนักรวม</th>
                <th class="min-w-100px w-150px text-end">ราคารวม</th>
              </tr>
            </thead>
            <!--end::Table head-->
            <!--begin::Table body-->
            <tbody>
              <tr
                class="border-bottom border-bottom-dashed"
                data-kt-element="item"
                v-for="(product, index) in shipmentD.productList"
                :key="index"
              >
                <td class="pe-7">
                  {{ index + 1 }}
                </td>
                <td class="pe-7" v-if="isAdmin">
                  {{ product.productName }} [{{
                    numberWithCommas(product.product_total_weight)
                  }}
                  กก.]
                  <br>
                  {{ product.productCode }} 
                  <el-tooltip
                    class="box-item"
                    effect="dark"
                    content="Copy"
                    placement="bottom"
                  >
                    <i class="fa fa-clipboard" aria-hidden="true" style="cursor: pointer" @click="copyText(product.productCode)"></i>
                  </el-tooltip>                  
                </td>
                <td class="pe-7" v-else>
                  {{ product.productName }} [{{
                    numberWithCommas(product.product_total_weight)
                  }}
                  กก.]
                </td>                
                <td class="ps-0 text-end">
                  {{ numberWithCommas(product.quantity, 0) }}
                </td>
                <td class="text-end">
                  {{ numberWithCommas(product.sell_price) }}
                </td>
                <!-- น้ำหนักรวม -->
                <td class="text-end text-nowrap">
                  <span data-kt-element="total">{{
                    numberWithCommas(product.product_total_weight )
                  }}</span>
                </td>
                <!-- ราคารวม -->
                <td class="text-end text-nowrap">
                  ฿
                  <span data-kt-element="total">{{
                    numberWithCommas(product.sell_price * product.quantity)
                  }}</span>
                </td>
              </tr>
            </tbody>
            <!--end::Table body-->
            <!--begin::Table foot-->

            <!--end::Table foot-->
          </table>
        </div>
        <div class="separator separator-dashed mb-5"></div>
        <div class="" v-if="shipmentD">
          <div class="row">
            <div class="col-md-5 col-lg-6 col-xl-7 mb-6">
              <div v-if="shipmentD.partnerNote">หมายเหตุ : {{ shipmentD.partnerNote }}</div>
              <br/><br/>
            </div>
            <div
              class="
                col-md-7 col-lg-6 col-xl-5
                fw-bolder
                text-gray-700
                fs-6
                card
                bg-light
                rounded-3
              "
            >
              <div class="card-body">
                <div class="d-flex justify-content-between mb-6">
                  <div>น้ำหนักรวม</div>
                  <div>{{ numberWithCommas(shipmentD.total_weight) }}</div>
                </div>
                <div class="d-flex justify-content-between mb-6">
                  <div>ค่าบริการขนส่ง</div>
                  <div>{{ numberWithCommas(shipmentD.delivery_price) }}</div>
                </div>
                <!-- <div class="d-flex justify-content-between mb-3">
                  <div>รวมเป็นเงิน</div>
                  <div>฿ {{ numberWithCommas(shipmentD.total_price) }}</div>
                </div>
                <div class="d-flex justify-content-between mb-3">
                  <div>ภาษีมูลค่าเพิ่ม {{ shipmentD.vat_rate }}%</div>
                  <div>฿ {{ numberWithCommas(shipmentD.total_price - shipmentD.total_price_no_vat) }}</div>
                </div>
                <div class="d-flex justify-content-between mb-3">
                  <div>ราคาไม่รวมภาษีมูลค่าเพิ่ม</div>
                  <div>฿ {{ numberWithCommas(shipmentD.total_price_no_vat) }}</div>
                </div> -->

                <!-- <div
                  class="
                    separator separator-dashed
                    my-5
                    border-1 border-gray-400
                  "
                ></div>
                <div class="d-flex justify-content-between mb-3">
                  <div>หักยอดชำระแล้ว</div>
                  <div>฿ {{ numberWithCommas(order.totalExcludeVat) }}</div>
                </div> -->

                <div
                  class="
                    separator separator-dashed
                    my-5
                    border-1 border-gray-400
                  "
                ></div>                
                <div class="d-flex justify-content-between mb-3">
                  <div>จำนวนเงินรวมทั้งสิ้น</div>
                  <div>฿ {{ numberWithCommas(shipmentD.total_price) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="fixed-bottom bg-white px-3 py-5 shadow-sm d-sm-block d-md-none">
          <div class="d-grid gap-2">

            <button class="btn btn-block btn-primary">ตกลง</button>
            <button class="btn btn-block btn-primary" @click="">พิมพ์ใบกำกับภาษี</button>
          </div>
        </div> -->
        <pdf-viewer ref="pdfViewerRef"></pdf-viewer>
      </div>
    </div>
    
  </div>
</template>

<script>
import ApiService from "../../core/services/ApiService";
import { numberWithCommas, formatDateFromISO, formatDateTimeFromISO } from "@/utils";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import PdfViewer from "../../components/modals/forms/PdfViewer.vue";
import { Modal } from "bootstrap";
import SearchCustomerAddressModal from "@/components/modals/search/SearchCustomerAddressModal";
import { validateRole, role } from "@/helpers/role"
import Swal from "sweetalert2/dist/sweetalert2.js";
import PrintDelivery2SOnline from '../../components/forms/PrintDelivery2SOnline.vue';

export default {
  components: { 
    PdfViewer, 
    SearchCustomerAddressModal,
    PrintDelivery2SOnline
  },
  props: {
    uoRefNo: String,
    partnerCode: String,
    fromOverDue:Boolean,
    status:String
  },
  data() {
    return {
      shipmentD: null,
      isLoading: false,
      requestInvoice: false,
      prevRoute: null,
      windowHeight: window.innerHeight,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin
    },
    backRoute() {
      if(this.isAdmin) {
        return { name: "partnerOrderList", params: { partnerCode: this.partnerCode}}
      } else {
        return {name: "orderList"} 
      }
    },
    orderStatus() {
      if(!this.order) return null
      if(this.order.canceled) return 'canceled'
      if(this.order.isPosted) return 'posted'
      if(this.order.requestTaxInvoice) return 'invoice'
      return null 
    },
    statusText() {
      if(this.orderStatus == "posted") {
        return "Post : " + this.order.invoiceCode;
      }
      return null;
    },
    productSelected() {
      return "";
        // return this.shipmentD?.productList
        //     .filter(p => p.isSelected)
        //     .map(p => {
        //         return p.product_id;
        //     })?.join(',') ?? '';
    },
    isJuristicPerson() {
      // คำนำหน้าที่เป็นนิติบุคคลตาม dropdown "คำนำหน้า" ของระบบ (บจ./บมจ./หจก./หสน./หสม.)
      // ส่วน นาย, น.ส., นาง, ร้าน เป็นบุคคลธรรมดา
      const juristicPrefixes = ["บจ.", "บมจ.", "หจก.", "หสน.", "หสม."];
      const name = (this.shipmentD && this.shipmentD.billName ? this.shipmentD.billName : "").trim();
      return juristicPrefixes.some((prefix) => name.startsWith(prefix));
    },
    billTaxBranchDisplay() {
      const branch = this.shipmentD && this.shipmentD.billTaxBranch;
      if (!branch || branch.trim() === "") {
        return this.isJuristicPerson ? "สำนักงานใหญ่" : "";
      }
      return branch;
    },
  },
  watch: {
    uoRefNo: {
      immediate: true,
      handler(val) {
        setCurrentPageBreadcrumbs("รายละเอียดส่งสินค้า");
        this.getShipmentD();
      },
    },
  },
  methods: {
    getShipmentD() {
      this.isLoading = true;
      let url = "orders/GetShipmentDetailFrom2SOnline"
      
      ApiService.query(
        url, 
        {
          params: {
            uoRefNo:this.uoRefNo
          }
        })
        .then((res) => {
          this.shipmentD = res.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally( () => {
          this.loading = false
          // this.selectedOrder = null
        })
    },
 
    openCustomerAddressModal() {
      this.$refs.customerAddressModal.show();
    },  
    summary({columns, data}) {
      const sums = [];
      columns.forEach((col, index) => {
        if(index === 0) {
          sums[index] = data.length + ' รายการ';
        }


        const sumColumns = ['aidNetTotal','aidVatBal','aidNetBal']
        if(sumColumns.includes(col.property)) {
          sums[index] = numberWithCommas(data.reduce(
            (prev, curr) => {
              return prev + ( curr.canceled ? 0 : curr[col.property] )
            },
            0
          ))
        }


      })
      
        return sums;
    }, 
    async copyText(Text) {
      // copy text TO the clipboard
      await navigator.clipboard.writeText(Text);
    },  
    
    async ConfirmShipment(Text) {
      const loader = this.$loading.show();
      try {
        var tempData;
          const { data } = await ApiService.post("Orders/ConfirmShipmentData", {
            uoRefNo:this.uoRefNo,
            // productSelected:this.productSelected
          });
          tempData = data;
          this.$swal("สำเร็จ", "ยืนยันส่งสินค้าแล้ว", "success");
          this.getShipmentD();
      } catch (error) {
        Swal.fire({
          text: "เกิดข้อผิดพลาด ไม่สามารถยืนยันส่งสินค้าได้!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "ปิด",
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then(() => {
          //this.hide();
        });
      }
      this.btnLoading = false;
      loader.hide();
    },     
    CancelShipmentData() {
      if(this.shipmentD.isComplete) return
      this.isLoading = true;
      
      this.$swal.fire({
        icon: 'question',
        title: 'ต้องการยกเลิกการส่งสินค้า?',
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "กลับ"
      })
      .then( result => {
        if(result.isConfirmed) {
          const loader = this.$loading.show();
          const params =  {
            uoRefNo:this.uoRefNo,
          }
          setTimeout(() => {
            ApiService.post("Orders/CancelShipmentData", params)
              .then((res) => {
                this.shipmentD.orderCancel = true;
                this.$swal("สำเร็จ", "ยกเลิกรายการส่งสินค้าแล้ว", "success");
              })
              .catch((err) => {
                this.$swal("เกิดข้อผิดพลาด", "", "error");
                if (err.resonse) {
                  console.log(err.resonse);
                }
              })
              .finally(() => {
                this.isLoading = false;
                loader.hide();
              });
          }, 500);
        }
      })
    },
    numberWithCommas,
    formatDateFromISO,
    formatDateTimeFromISO
  },
};
</script>

<style scope>
  /* .invoice-check-box.el-checkbox__input.is-disabled+span.el-checkbox__label */
  .el-checkbox__input.is-disabled+span.el-checkbox__label
  {
    color: #409eff !important;
  }
  .btn-green {
    color: #fff;
    background-color: #35a5b6;
    border-color: #117a8b;
  }
  .btn-dark-green {
      color: #fff;
      background-color: #066f8f;
  }
  .icon-green {
      color:  #117a8b;
  }
</style>
